export const BEP20USDT_CONTRACT = "0x55d398326f99059fF775485246999027B3197955";
export const BEP20BUSD_CONTRACT = "0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56";//"0xeD24FC36d5Ee211Ea25A80239Fb8C4Cfd80f12Ee";
export const BEP20PRESALE_CONTRACT = "0x882FE5a5a132fc6f91Ceb7FCce3B36E19E4E04cC";
export const BEP20MAF_CONTRACT = "0x8ddCDB7a4862E4c0f99b91050f228f2E702772aB";
